import styled from "styled-components";

export default styled.input.attrs({ type: "text" })`
    border: 1px solid #ddd;
    border-radius: 3px;
    min-width: 200px;
    padding: 6px 10px;

    &::placeholder {
        color: #ddd;
    }
`;
